import React, { forwardRef } from 'react';

import Select from '@atlaskit/select';

import { getDayOptions } from '../../utils';

import { type DayPickerProps } from './types';

export const DayPicker = forwardRef<any, DayPickerProps>(
	({ weekStartDay, value, testId, variant = 'default', ...selectProps }, ref) => {
		const days = getDayOptions({ weekStartDay: weekStartDay || 1 }, variant);

		return (
			<Select
				ref={ref}
				placeholder={days[0].label.slice(0, 3)}
				value={value}
				{...selectProps}
				options={days}
				menuPosition="fixed"
				testId={testId}
			/>
		);
	},
);
